module.exports = __webpack_public_path__ + "img/delivery-placeholder.714eb35b.svg";